<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
    <div
      class="bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto"
    >
      <div class="flex justify-between items-start mb-4">
        <h3 class="text-lg font-medium text-blue-400">Ocenite korisnika</h3>
        <button
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-300 transition-colors"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div class="mb-4">
        <div class="text-sm text-gray-300 mb-2">Izaberite ocenu:</div>
        <div class="flex justify-center space-x-6">
          <button
            @click="$emit('setRatingLike', true)"
            class="p-3 rounded-lg flex flex-col items-center transition-colors"
            :class="
              ratingModal.isLike === true
                ? 'bg-green-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mb-2"
            >
              <path
                d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
              ></path>
            </svg>
            <span class="font-medium">Pozitivno</span>
          </button>
          <button
            @click="$emit('setRatingLike', false)"
            class="p-3 rounded-lg flex flex-col items-center transition-colors"
            :class="
              ratingModal.isLike === false
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="mb-2"
            >
              <path
                d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
              ></path>
            </svg>
            <span class="font-medium">Negativno</span>
          </button>
        </div>
      </div>

      <div class="mb-4">
        <label for="ratingComment" class="block text-sm text-gray-300 mb-2"
          >Vaš komentar (opcionalno):</label
        >
        <textarea
          id="ratingComment"
          v-model="ratingModal.comment"
          class="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm"
          rows="3"
          placeholder="Opišite vaše iskustvo sa ovim korisnikom..."
        ></textarea>
      </div>

      <div class="text-sm text-gray-400 mb-4">
        Tip ocene:
        <span class="font-medium">{{
          ratingModal.ratingType === 'buyer'
            ? 'Prodavac ocenjuje kupca'
            : 'Kupac ocenjuje prodavca'
        }}</span>
      </div>

      <div class="flex justify-end space-x-3">
        <button
          @click="$emit('close')"
          class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 transition-colors"
        >
          Otkaži
        </button>
        <button
          @click="$emit('submit')"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Potvrdi
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RatingModal',
  props: {
    otherUser: {
      type: Object as PropType<any>,
      default: null,
    },
    ratingModal: {
      type: Object as PropType<{
        show: boolean;
        isLike: boolean | null;
        comment: string;
        ratingType: 'buyer' | 'seller';
      }>,
      required: true,
    },
  },
  emits: ['close', 'setRatingLike', 'submit'],
});
</script>
